import React from "react";
import "./AlertBox.css";
import { BiCheckCircle } from "react-icons/bi";

const AlertBox = ({
  title,
  message,
  isOpen,
  buttons,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  type,
}) => {
  if (!isOpen) return null;

  return (
    <div className="alert-overlay">
      <div className="alert-box">
        <div className="square-one">
          <div className="square-two">
            <div className="square-three">
              <div className="square-four" />
            </div>
          </div>
        </div>

        <div className={`alert-box-symbol alert-box-symbol-${type}`}>
          <BiCheckCircle size={28} />
        </div>

        <h2 className={`alert-title alert-title-${type}`}>{title}</h2>
        <p className="alert-message">{message}</p>

        <div className="alert-actions">
          {buttons ? (
            buttons.map((button, index) => (
              <button
                key={index}
                className={`alert-button ${button.styleType}`}
                onClick={button.onClick}
                style={{ fontSize: '13px', fontWeight: '400' }}
              >
                {button.text}
              </button>
            ))
          ) : (
            <>
              {onCancel &&
                <button className="alert-button alert-cancel" onClick={onCancel}>
                  {cancelText}
                </button>
              }

              <button
                className="alert-button alert-confirm"
                onClick={onConfirm}
              >
                {confirmText}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertBox;
